export default {
    HEADER: 'Product category',
    PLACEHOLDER_NAME: 'Enter category name',
    LABEL_NAME: 'Category name',
    LABEL_STATUS: 'Status',
    SAVE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
};
